(function ($) {
    var type = [
        'property',
        'shareholding-management',
        'managed-portfolio'
    ];

    var hasFirstManualScroll = false;

    var menuitem, navigation, navshow, onUrl, onHome, pageAncester, navitem, navsubitem, currentNavItem;

    menuitem = $('.button-menu li');
    if (menuitem.length <= 0)
        return;

    navigation = $('.main-navigation');

    onHome = $('body').hasClass('home');
    pageAncester =  navigation.find('.current_page_ancestor');

    menuitem.on('click', function (e) {
        var that = $(this);
        switch(e.target.getAttribute('id')){
            case 'btn-menu-contact':
                currentNavItem = $("[href='"+originUrl+"#contact']");
                linkToContact('performance');
                var query = "[href='"+originUrl+"']";
                $(query).parent().removeClass('current_page_item');
                $("[href='"+originUrl+"#contact']").parent().addClass('current_page_item');
                menuitem.removeClass('active');
                break;
            case 'btn-close-menu':
                hiddenMenu();
                break;
            case 'btn-close-menu-mobile':
                hiddenMenu();
                break;
            default:
                nav = navigation;
                nav.css('position', 'fixed');
                scrollBtn = $('.scroll-down-view');
        
                menuitem.removeClass('active');
                that.addClass('active');
        
                navshow = null;
                navigation.removeClass('onshow');
                nav.addClass('onshow');
                navshow = nav;
        
                showMenu();
        }
    });

    
    navitem = $('.menu .menu-item');
    navsubitem = $('.menu .menu-item-has-children .sub-menu .menu-item');
    var navasubitem = $('.menu .menu-item-has-children .sub-menu .menu-item a');
    navitem.hover(function(){
        navitem.removeClass('current_page_item');
        $('.menu .menu-item a').removeClass('current_page_item');
        navsubitem.removeClass('current_page_item');
        navasubitem.removeClass('current_page_item');
    }, function(){});

    $('#menu-menu-1').mouseleave(function(){
        currentNavItem.addClass('current_page_item');
    });

    $('#btn-close-menu-mobile').on('click', function(){
        hiddenMenu();
    });

    $('body').on('click', '.menu-backdrop', function (e) {
        hiddenMenu();
    });

    function showMenu() {
        $('body').append('<div class="menu-backdrop"></div>');
    }

    function hiddenMenu() {
        menuitem.removeClass('active');
        navigation.removeClass('onshow');
        $('.menu-backdrop').remove();
    }

    //link to contact with to mode: standard and performance
    //mode default is standard
    function linkToContact(mode){
        hasFirstManualScroll = false;
        mode = mode || 'standard';
        if($('#contact-home-page') && $('#contact-home-page').length > 0 ){
            navigation.removeClass('onshow');
            $('.menu-backdrop').remove();
            if(mode == 'standard'){
                window.scrollTo(0, $('#contact-home-page')[0].offsetTop);
            }
            else {
                $('html, body').animate({
                    scrollTop: $('#contact-home-page')[0].offsetTop
                }, 1000, function() {
                    $(window).scroll(function(){
                        if($(this).scrollTop() != $('#contact-home-page')[0].offsetTop)
                            hasFirstManualScroll = true;
                    });
                });
            }
        }
        window.location.href = originUrl+'#contact';
    }

    //link to portfolio with to mode: standard and performance
    //mode default is standard
    function linkToPortfolio(type, mode){
        hasFirstManualScroll = false;
        mode = mode || 'standard';
        navigation.removeClass('onshow');
        $('.menu-backdrop').remove();
        var query = "[href='"+originUrl+"portfolio/']";
        // $(query).css('background', 'none');
        // $(query).css('color', '#fff');
        if (!onHome){
            if($('#'+type+'-portfolio-page') && $('#'+type+'-portfolio-page').length > 0){
                if(mode == 'standard'){
                    window.scrollTo(0, $('#'+type+'-portfolio-page')[0].offsetTop);
                }
                else {
                    $('html, body').animate({
                        scrollTop: $('#'+type+'-portfolio-page')[0].offsetTop
                    }, 1000, function() {
                        $(window).scroll(function(){
                            if($(this).scrollTop() != $('#'+type+'-portfolio-page')[0].offsetTop)
                                hasFirstManualScroll = true;
                        });
                    });
                }
            }
        }
        window.location.href = originUrl+'portfolio/#'+type;
    }

    function eventScrollToTargetPerformance(){
        if (onHome){
            if (window.location.hash == '#contact') {
                linkToContact('performance');
                var query = "[href='" + originUrl + "']";
                navigation.find(query).parent().removeClass('current_page_item');
            }
            else {
                var query = "[href='" + originUrl + "#contact']";
                navigation.find(query).parent().removeClass('current_page_item');
            }
            currentNavItem = $('#menu-menu-1').find('.current_page_item');
        }

        if (pageAncester.length > 0) {
            if (window.location.hash.indexOf('#') >= 0) {
                var value = window.location.hash.replace('#', '');
                linkToPortfolio(value, 'performance');
                disableSubMenu(type);
                var query = "[href='" + originUrl + "portfolio/']";
                $(query).parent().removeClass('current_page_item');
                $("[href='" + originUrl + "portfolio/#" + value + "']").parent().addClass('current_page_item');
            }
            else {
                var query = "[href='" + originUrl + "portfolio/']";
                $(query).parent().removeClass('current_page_item');
                disableSubMenu(type);
                // $(query).css('background', '#fdc52a');
                // $(query).css('color', '#292929');
                $(query).addClass('current_page_item');
            }
            currentNavItem = $('#menu-menu-1').find('.current_page_item');
        }

    }

    function eventScrollToTargetStandard(){
        if (onHome){
            if(window.location.hash == '#contact'){
                linkToContact();
                var query = "[href='"+originUrl+"']";
                navigation.find(query).parent().removeClass('current_page_item');
            }
            else {
                var query = "[href='"+originUrl+"#contact']";
                navigation.find(query).parent().removeClass('current_page_item');
            }
        }

        if (pageAncester.length > 0){
            type.forEach(function(value, index){
                if(window.location.hash == ('#'+value)){
                    linkToPortfolio(value);
                    disableSubMenu(type);
                    var query = "[href='"+originUrl+"portfolio/']";
                    $(query).parent().removeClass('current_page_item');
                    $("[href='"+originUrl+"portfolio/#"+value+"']").addClass('current_page_item');
                }
            });
        }
    }

    function disableSubMenu(type){
        type.forEach(function(value, index){
            $("[href='"+originUrl+"portfolio/#"+value+"']").removeClass('current_page_item');
        });
    }

    $(document).ready(function(){
        $("[href='"+originUrl+"#contact']").on('click', function(){
            currentNavItem = $("[href='"+originUrl+"#contact']").parent();
            linkToContact('performance');
            var query = "[href='"+originUrl+"']";
            $(query).parent().removeClass('current_page_item');
            $("[href='"+originUrl+"#contact']").parent().addClass('current_page_item');
            menuitem.removeClass('active');
        });

        $("[href='"+originUrl+"portfolio/#property']").on('click', function(e){
            currentNavItem = $("[href='"+originUrl+"portfolio/#property']").parent();
            linkToPortfolio("property", 'performance');
            disableSubMenu(type);
            var query = "[href='"+originUrl+"portfolio/']";
            $(query).parent().removeClass('current_page_item');
            $("[href='"+originUrl+"portfolio/#property']").parent().addClass('current_page_item');
            menuitem.removeClass('active');
        });

        $("[href='"+originUrl+"portfolio/#shareholding-management']").on('click', function(e){
            currentNavItem = $("[href='"+originUrl+"portfolio/#shareholding-management']").parent();
            linkToPortfolio("shareholding-management", 'performance');
            disableSubMenu(type);
            var query = "[href='"+originUrl+"portfolio/']";
            $(query).parent().removeClass('current_page_item');
            $("[href='"+originUrl+"portfolio/#shareholding-management']").parent().addClass('current_page_item');
            menuitem.removeClass('active');
        });

        $("[href='"+originUrl+"portfolio/#managed-portfolio']").on('click', function(e){
            currentNavItem = $("[href='"+originUrl+"portfolio/#managed-portfolio']").parent();
            linkToPortfolio("managed-portfolio", 'performance');
            disableSubMenu(type);
            var query = "[href='"+originUrl+"portfolio/']";
            $(query).parent().removeClass('current_page_item');
            $("[href='"+originUrl+"portfolio/#managed-portfolio']").parent().addClass('current_page_item');
            menuitem.removeClass('active');
        });

        eventScrollToTargetPerformance();
    });

    window.onload = function(){
        if(!hasFirstManualScroll)
            setTimeout(function(){
                eventScrollToTargetStandard();
            },0);
    }
})(jQuery);